// extracted by mini-css-extract-plugin
export default {"certificatePreview":"z22U9N_k_9iNagdGxegS","fileExtensionBox":"gR_PqEhMxWBg65hcSTZm"};